<script>
import ElSlider from 'element-ui/lib/slider'

export default {
  // SliderButton 依赖直接父级与 Element 的组件名，保留原有组件层级。
  name: 'ElSlider',
  extends: ElSlider,
  props: {
    variant: {
      type: String,
      default: 'default',
      validator: value => ['default', 'compact'].includes(value)
    }
  },
  render (h) {
    const context = Object.create(this)
    Object.defineProperty(context, 'tooltipClass', {
      value: ['ui-tooltip-popper', this.tooltipClass].filter(Boolean).join(' ')
    })
    const vnode = ElSlider.render.call(context, h)
    vnode.data = vnode.data || {}
    vnode.data.class = [vnode.data.class, 'ui-slider', `ui-slider--${this.variant}`]
    return vnode
  }
}
</script>
